/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelLoanDto } from '../../models/backend-business-angel-loan-dto';
import { BackendBusinessAngelLoanRequestDto } from '../../models/backend-business-angel-loan-request-dto';

export interface VentureFundsBusinessAngelLoansUpdate$FormData$Params {
  id: number;
  body: BackendBusinessAngelLoanRequestDto;
}

export function ventureFundsBusinessAngelLoansUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelLoansUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelLoansUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelLoanDto>;
    }),
  );
}

ventureFundsBusinessAngelLoansUpdate$FormData.PATH = '/api/venture_funds/business-angel-loans/{id}/';
